// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/Forfarshire large map.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@font-face {
font-family:"source-sans-pro";
src:url("https://use.typekit.net/af/61f808/00000000000000003b9b3d63/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/61f808/00000000000000003b9b3d63/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/61f808/00000000000000003b9b3d63/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:400;font-stretch:normal;
}
@font-face {
font-family:"ivypresto-headline";
src:url("https://use.typekit.net/af/e456f5/00000000000000007735e5a2/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/e456f5/00000000000000007735e5a2/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/e456f5/00000000000000007735e5a2/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:400;font-stretch:normal;
}

p {
    font-family: "source-sans-pro", sans-serif;
    font-style: normal;
    font-weight: 200;
}

figcaption {
    font-family: "source-sans-pro", sans-serif;
    font-style: normal;
    font-weight: 200;
    font-size: 14px;
}

h1 {
    font-family: "ivypresto-headline", serif;
    font-weight: 400;
    font-style: normal;
}

@media screen and (max-width: 575px) {
    h1 {
        font-size: 64px;
    }

    h2 {
        font-size: 22px;
    }

    .important-text {
        font-size: 18px;
    }
}

@media screen and (min-width: 576px) {
    h1 {
        font-size: 85px;
    }

    .important-text {
        font-size: 22px;
    }
}

/*	≥576px*/
/*Medium	md	≥768px*/

.important-text {
    font-weight: 500;
}

.dropdown-item {
    background-color: #212529 !important;
}

.dropdown-item:focus,
.dropdown-item:active {
    background-color: #949494 !important;
}


.parallax {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    min-height: 400px;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT;;cAEU;IACV,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI;aACS;AACb;;AAEA;AACA,6BAA6B;AAC7B,mgBAAmgB;AACngB,iBAAiB,CAAC,iBAAiB,CAAC,eAAe,CAAC,mBAAmB;AACvE;AACA;AACA,gCAAgC;AAChC,mgBAAmgB;AACngB,iBAAiB,CAAC,iBAAiB,CAAC,eAAe,CAAC,mBAAmB;AACvE;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,UAAU;AACV,mBAAmB;;AAEnB;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,oCAAoC;AACxC;;;AAGA;IACI,yDAA0D;IAC1D,iBAAiB;IACjB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B","sourcesContent":["body {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@font-face {\nfont-family:\"source-sans-pro\";\nsrc:url(\"https://use.typekit.net/af/61f808/00000000000000003b9b3d63/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3\") format(\"woff2\"),url(\"https://use.typekit.net/af/61f808/00000000000000003b9b3d63/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3\") format(\"woff\"),url(\"https://use.typekit.net/af/61f808/00000000000000003b9b3d63/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3\") format(\"opentype\");\nfont-display:auto;font-style:normal;font-weight:400;font-stretch:normal;\n}\n@font-face {\nfont-family:\"ivypresto-headline\";\nsrc:url(\"https://use.typekit.net/af/e456f5/00000000000000007735e5a2/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3\") format(\"woff2\"),url(\"https://use.typekit.net/af/e456f5/00000000000000007735e5a2/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3\") format(\"woff\"),url(\"https://use.typekit.net/af/e456f5/00000000000000007735e5a2/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3\") format(\"opentype\");\nfont-display:auto;font-style:normal;font-weight:400;font-stretch:normal;\n}\n\np {\n    font-family: \"source-sans-pro\", sans-serif;\n    font-style: normal;\n    font-weight: 200;\n}\n\nfigcaption {\n    font-family: \"source-sans-pro\", sans-serif;\n    font-style: normal;\n    font-weight: 200;\n    font-size: 14px;\n}\n\nh1 {\n    font-family: \"ivypresto-headline\", serif;\n    font-weight: 400;\n    font-style: normal;\n}\n\n@media screen and (max-width: 575px) {\n    h1 {\n        font-size: 64px;\n    }\n\n    h2 {\n        font-size: 22px;\n    }\n\n    .important-text {\n        font-size: 18px;\n    }\n}\n\n@media screen and (min-width: 576px) {\n    h1 {\n        font-size: 85px;\n    }\n\n    .important-text {\n        font-size: 22px;\n    }\n}\n\n/*\t≥576px*/\n/*Medium\tmd\t≥768px*/\n\n.important-text {\n    font-weight: 500;\n}\n\n.dropdown-item {\n    background-color: #212529 !important;\n}\n\n.dropdown-item:focus,\n.dropdown-item:active {\n    background-color: #949494 !important;\n}\n\n\n.parallax {\n    background-image: url(\"images/Forfarshire large map.jpeg\");\n    min-height: 400px;\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
